export default __webpack_public_path__ + "public/icons/reporting.png?b798f2f256555bef1a6e12839e0d392c";